export const setloader = (post) => {
    return async dispatch => {
        return dispatch({
            type: 'LOADER',
            payload: post
        });
    };
};